import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/format'
import { describeJobResult, isSyncRequestResult } from '@/lib/jobRuns'
import type { JobResultCount } from '@/lib/jobRuns'
import type { JobRun } from '@/api/types'

const EMPTY_VALUE = '–'
const SYNC_REQUEST_NOTE = 'Betalningarna kommer när Capway svarar.'

function JobResultCountItem({ count }: { count: JobResultCount }): React.ReactElement {
  return (
    <span className="whitespace-nowrap">
      <span className="text-muted-foreground">{count.label}</span>{' '}
      <span className={cn('font-medium tabular-nums', count.isProblem && 'text-destructive')}>{formatNumber(count.value)}</span>
    </span>
  )
}

export function JobRunResult({ run }: { run: JobRun | null }): React.ReactElement {
  if (run === null) {
    return <span className="text-muted-foreground">{EMPTY_VALUE}</span>
  }

  if (run.error !== null) {
    return <p className="break-words text-destructive">{run.error}</p>
  }

  const counts = describeJobResult(run.result)
  const isSyncRequest = isSyncRequestResult(run.result)

  return (
    <div className="space-y-1">
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        {counts.map((count) => (
          <JobResultCountItem
            key={count.key}
            count={count}
          />
        ))}
      </div>
      {isSyncRequest && <p className="text-xs text-muted-foreground">{SYNC_REQUEST_NOTE}</p>}
    </div>
  )
}
